export const isMobile = () => {
    const mql = window.matchMedia("screen and (max-width: 600px)");
    return mql.matches;
};